module.exports = __webpack_public_path__ + "static/media/public-directory-build.993a3095.png";